<template>
    <div>
      <national-patent-receiving-office-list></national-patent-receiving-office-list>
    </div>
  </template>
  <script>
  export default {
  }
  </script>
